import { Button, Col, Divider, Form, Input, Row, Modal } from "antd";
import { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";
import * as String from "../commons/string";

function DriverLicenseInfo({ driverLicenseId }: { driverLicenseId?: number }) {
    const alert = useAlert();
    const [license, setLicense] = useState<Types.DriverLicenseDto>();

    useEffect(() => {
        driverLicenseId && requestGetDriverLicense();
    }, [driverLicenseId]);

    //get license
    const requestAxiosGetDriverLicense = async () => {
        const response = await utilAxiosWithAuth().get(Request.DRIVER_LICENSE_URL + driverLicenseId);
        return response.data;
    };

    const {
        loading: loadingGetDriverLicense,
        error: errorGetDriverLicense,
        data: resultGetDriverLicense,
        execute: requestGetDriverLicense,
    } = useAsyncAxios(requestAxiosGetDriverLicense);

    useEffect(() => {
        if (!resultGetDriverLicense) return;

        setLicense(resultGetDriverLicense.driverLicense);
    }, [resultGetDriverLicense]);

    useEffect(() => {
        if (!errorGetDriverLicense) return;

        console.log("errorGetDriverLicense", errorGetDriverLicense);
    }, [errorGetDriverLicense]);

    //delete license
    const requestAxiosDeleteDriverLicense = async () => {
        const response = await utilAxiosWithAuth().delete(Request.DRIVER_LICENSE_URL + driverLicenseId);
        return response.data;
    };

    const {
        loading: loadingDeleteDriverLicense,
        error: errorDeleteDriverLicense,
        data: resultDeleteDriverLicense,
        execute: requestDeleteDriverLicense,
    } = useAsyncAxios(requestAxiosDeleteDriverLicense);

    useEffect(() => {
        if (resultDeleteDriverLicense === null) return;

        requestGetDriverLicense();
        alert.setAlert(AlertType.SUCCESS, "면허증 초기화 완료", "면허증 초기화를 완료하였습니다.");
    }, [resultDeleteDriverLicense]);

    useEffect(() => {
        if (errorDeleteDriverLicense === null) return;
        console.log("errorDeleteDriverLicense", errorDeleteDriverLicense);
    }, [errorDeleteDriverLicense]);

    const showResetLicensePopup = () => {
        Modal.confirm({
            title: "면허정보 초기화",
            content: "면허정보를 초기화 하시겠습니까?",
            okText: "확인",
            onOk() {
                requestDeleteDriverLicense();
            },
            cancelText: "취소",
            onCancel() {},
            centered: true,
        });
    };

    return (
        <div>
            <Row justify="space-between">
                <Col span={6}>
                    <Divider orientation="left">
                        <span>면허정보</span>
                    </Divider>
                </Col>
                <Col span={18} style={{ textAlign: "right", alignContent: "center" }}>
                    <Button onClick={() => showResetLicensePopup()} disabled={license ? false : true}>
                        면허증 초기화
                    </Button>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item className="searchForm" name="licenseType" label="면허 종류">
                        <Input disabled placeholder={license?.licenseType || String.dash} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item className="searchForm" name="licenseNumber" label="면허번호">
                        <Input disabled placeholder={license?.licenseNumber || String.dash} />
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );
}

export default DriverLicenseInfo;
